/* src/app/shared/components/spinner/spinner.component.scss */
.ahe-ui-loading-spinner {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
}
/*# sourceMappingURL=spinner.component.css.map */
